import { Dialog } from "@mui/material";
import styled from "styled-components";

export const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 100%;
    max-width: 600px;
    border-radius: 12px;
    padding: 24px;
  }
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;

  h2 {
    font-size: 24px;
    font-weight: 600;
    margin: 0;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;
  color: #666;
  &:hover {
    color: #333;
  }
`;